/* global axios */
import ApiClient from './ApiClient';

class StaffChatApi extends ApiClient {
  constructor() {
    super('staff_chats', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create({ userId }) {
    return axios.post(this.url, { user_id: userId });
  }

  createGroup({ userIds, name }) {
    return axios.post(this.url, { user_ids: userIds, name });
  }

  getMessages(staffChatId) {
    return axios.get(`${this.url}/${staffChatId}/messages`);
  }

  createMessage({ staffChatId, content, files }) {
    if (files?.length) {
      const payload = new FormData();
      if (content) {
        payload.append('content', content);
      }
      files.forEach(file => {
        payload.append('attachments[]', file);
      });
      return axios.post(`${this.url}/${staffChatId}/messages`, payload);
    }

    return axios.post(`${this.url}/${staffChatId}/messages`, { content });
  }

  updateLastSeen(staffChatId) {
    return axios.post(`${this.url}/${staffChatId}/update_last_seen`);
  }

  update(id, { name }) {
    return axios.patch(`${this.url}/${id}`, { name });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new StaffChatApi();
